import { useCultureCode } from '@mews-commander/core';
import { getCurrencyCultureInfo, getCurrencyLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { CurrencyInputField, CurrencyInputFieldProps } from '@mews-commander/form';
import { useCommanderSelector } from '@mews-commander/utils';

type CurrencyInputFieldWrapperProps = CurrencyInputFieldProps & { currencyCode: string };
export const CurrencyInputFieldWrapper = ({ currencyCode, ...props }: CurrencyInputFieldWrapperProps) => {
    const cultureCode = useCultureCode();

    const currencyInfo = useCommanderSelector((state) => getCurrencyCultureInfo(state, { cultureCode }));
    const currencyLocalization = useCommanderSelector((state) =>
        getCurrencyLocalizationInfo(state, { currencyCode, cultureCode })
    );

    return (
        <CurrencyInputField
            size="medium"
            allowNegative={false}
            {...currencyInfo}
            {...currencyLocalization}
            {...props}
        />
    );
};
